import { ComplexValue, LoadOptions, Value } from 'app/types-shared';
import { WithMetroLineWrappedComponentProps } from 'app/components/metro-line/types';
import { ExternalUrlAdminTranslation } from '../constants';
import { ExternalUrlSectionType } from './metroline/types';
import {
  ExternalUrlAdminFormState, ExternalUrlItem, ExternalUrlItemValidation
} from './types-store';

export interface ExternalUrlItemWire {
  disabled: string;
  code: Value;
  language: Value[];
  urlTemplate?: string;
  exclude: Value[];
}

export interface ExternalUrlSectionProps {
  actionType: ExternalUrlActionType;
  externalUrlItem: ExternalUrlItem;
  options: {
    [key: string]: {
      fetching: boolean;
      codes?: ComplexValue<number | string>[];
    };
  };
  locale: string;
  validation: ExternalUrlItemValidation;
  translation: ExternalUrlAdminTranslation;
  section: ExternalUrlSectionType;
  fetching?: boolean;
  updateExcludedFields: (excludedFields: ComplexValue<number>[]) => void;
  loadOptions: (id: string,
    componentEndpoint: string,
    loadOptionsParams: LoadOptions,
    optionsParams?: any) => void;
  updateItem: (item: Partial<ExternalUrlItem>) => void;
  updateValidation: (validation: ExternalUrlItemValidation) => void;
  resetValidation: (key: string) => void;
  translationAdminAccess: boolean;
  displayError: (errorMessage: string) => void;
}

export type ExternalUrlSection = ExternalUrlSectionProps & WithMetroLineWrappedComponentProps<ExternalUrlSectionType>;

export interface ExternalUrlContainerProps {
  actionType: ExternalUrlActionType;
  formState: ExternalUrlAdminFormState;
  shouldPrompt: boolean;
  mainLanguage: number;
  validation: ExternalUrlItemValidation;
  translation: ExternalUrlAdminTranslation;
  children?: React.ReactNode;
  switchTranslationsToggle: (value: boolean) => void;
  saveExternalUrl: (item: ExternalUrlItem) => void;
  deleteExternalUrl: () => void;
  updateValidation: (validation: ExternalUrlItemValidation) => void;
  displayError: (errorMessage: string) => void;
}

export interface ExternalUrlFormProps {
  actionType?: ExternalUrlActionType;
  formState: ExternalUrlAdminFormState;
  shouldPrompt: boolean;
  mainLanguage: number;
  options: {
    [key: string]: {
      fetching: boolean;
      codes?: ComplexValue<number | string>[];
    };
  };
  section: ExternalUrlSectionType;
  locale: string;
  translation: ExternalUrlAdminTranslation;
  translationAdminAccess: boolean;
  saveExternalUrl: (item: ExternalUrlItem) => void;
  deleteExternalUrl: () => void;
  updateItem: (item: Partial<ExternalUrlItem>) => void;
  changeLanguage: (languageId: number, text: string) => void;
  copyLanguageToAll: (languageId: number, successMessage: string) => void;
  changeLongDescription: (languageId: number, text: string) => void;
  copyLongDescriptionToAll: (languageId: number, successMessage: string) => void;
  showTranslations: boolean;
  switchTranslationsToggle: (showTranslations: boolean) => void;
  updateExcludedFields: (excludedFields: ComplexValue<number>[]) => void;
  loadOptions: (id: string,
    componentEndpoint: string,
    loadOptionsParams: LoadOptions,
    optionsParams?: any) => void;
  updateValidation: (validation: ExternalUrlItemValidation) => void;
  resetValidation: (key: string) => void;
  displayError: (errorMessage: string) => void;
}

export interface ExternalUrlLanguageProps extends WithMetroLineWrappedComponentProps<ExternalUrlSectionType> {
  language: ComplexValue<number>[];
  longDescription: ComplexValue<number>[];
  mainLanguage: number;
  languageOptions: ComplexValue<number>[];
  showTranslations: boolean;
  validation: ExternalUrlItemValidation;
  translation: ExternalUrlAdminTranslation;
  section: string;
  switchTranslationsToggle: (value: boolean) => void;
  changeLanguage: (languageId: number, text: string) => void;
  copyLanguageToAll: (languageId: number, successMessage: string) => void;
  changeLongDescription: (languageId: number, text: string) => void;
  copyLongDescriptionToAll: (languageId: number, successMessage: string) => void;
}

export interface ExternalUrlStickyHeaderProps {
  actionType: ExternalUrlActionType;
  shouldPrompt: boolean;
  externalUrlItem: ExternalUrlItem;
  name: string;
  fetching: boolean;
  translation: ExternalUrlAdminTranslation;
  displayError: (errorMessage: string) => void;
  onSave: () => void;
  onDelete: () => void;
}

export enum ExternalUrlActionType {
  add = 'add',
  edit = 'edit'
}
